import React, { Component } from 'react';
import { Button } from 'antd';
import AudioReactRecorder, { RecordState } from 'audio-react-recorder';
import Timer from '../Timer';
import convertAudioStereoToMono from '../AudioUtils';

import './AudioRecorder.css';
import microphone from '../../assets/player/microphone.webp';
import gif from '../../assets/gif.gif'
import { debounce } from 'lodash';

// 目标组件的定义
interface MyAudioRecorderProps {
	onAudioRecorded: Function;
	tab?: string,
	start?: Function,
	stopRecord?: Function
	tabsName?: string
	disabled?: boolean
}

interface MyAudioRecorderState {
	recordState: RecordState | null;
	audioData: any | null; // 根据实际情况定义audioData的类型
	isMediaStreamAvailable: boolean;
	isCancel: boolean;
}


class AudioRecorder extends Component<MyAudioRecorderProps, MyAudioRecorderState> {
	constructor(props: MyAudioRecorderProps) {
		super(props);

		this.state = {
			recordState: null,
			audioData: null, // 添加 audioData 状态来存储录音数据
			isMediaStreamAvailable: true,
			isCancel: false,
		};
	}

	componentDidUpdate(prevProps: MyAudioRecorderProps) {
		if (!prevProps.disabled && this.props.disabled && this.state.recordState === RecordState.START) {
			this.handleCancelRecord();
		}
	}

	get disabled() {
		return this.props.disabled
	}

	checkAudioRecorderAvailable = () => {
		if (!navigator || !navigator.mediaDevices) {
			alert('获取录音设备失败，请检查浏览器或录音设备！');
			this.setState({ isMediaStreamAvailable: false });
			return false;
		}
		// 使用getUserMedia获取媒体流
		navigator.mediaDevices
			.getUserMedia({ audio: true, video: false })
			.then((stream) => {
				// 如果成功获取媒体流，do something ...
				console.log('获取媒体流成功.');
				this.setState({ isMediaStreamAvailable: true });

				// 关闭媒体流以释放资源
				stream.getTracks().forEach((track) => {
					track.stop();
				});
				return true;
			})
			.catch((error) => {
				console.error('获取媒体流失败:', error);
				alert('获取媒体流失败，不支持录音，请尝试开启 HTTPS: ' + error.message);
				this.setState({ isMediaStreamAvailable: false });
			});
		return false;
	}

	start = () => {
		this.setState({
			recordState: RecordState.START,
			isCancel: false,
		});
		if (this.props?.start) {
			this.props?.start();
		}
	}

	stop = () => {
		this.setState({
			recordState: RecordState.STOP,
		});
		if (this.props?.stopRecord) {
			this.props?.stopRecord()
		}
	}

	// audioData contains blob and url
	onStop = (audioData) => {
		console.log('audioData', audioData);
		if (this.state.isCancel) {
			console.log('Cancel recording, clear audio data.');
			this.setState({ audioData: null });
			this.props.onAudioRecorded('');
			return;
		}

		// 设置录音数据到状态
		this.setState({ audioData });

		const reader = new FileReader();
		reader.onload = (event) => {
			if (event.target && event.target.result) {
				const base64Data = event.target.result.toString().split(',')[1];
				this.props.onAudioRecorded(base64Data); // 将base64编码的数据传递给父组件
			}
		};
		convertAudioStereoToMono(audioData.blob)
			.then((monoBlob) => {
				console.log("双声道转单声道，音频处理完成");
				console.log(typeof monoBlob);
				console.log(monoBlob);

				reader.readAsDataURL(monoBlob);
			})
			.catch((error) => {
				console.error("双声道转单声道，音频处理出错", error);
			});

	}

	handleStartRecord = () => {
		let isFisrtCheck = true;
		if (isFisrtCheck || !this.state.isMediaStreamAvailable) {
			console.log('check audio available');
			this.checkAudioRecorderAvailable();
			isFisrtCheck = false;
		}
		console.log('isMediaStreamAvailable:', this.state.isMediaStreamAvailable);
		if (this.state.isMediaStreamAvailable) {
			console.log('start recording');
			this.start();
		}
	};

	handleCancelRecord = () => {
		this.setState({ isCancel: true });
		this.stop();
	}
	toAudio = debounce((recording) => {
		if (this.disabled) {
			return false
		}
		recording ? this.stop() : this.handleStartRecord()
	},500)

	handleAudioToggle = (recording: boolean) => {
		if (this.disabled) {
			return
		}
		// Streaming playback must create/resume AudioContext in the original
		// click event; delaying it through debounce triggers browser autoplay blocking.
		if (this.props.tab === 'asr') {
			recording ? this.stop() : this.handleStartRecord()
			return
		}
		this.toAudio(recording)
	}


	render() {
		const { recordState, audioData, isMediaStreamAvailable } = this.state;
		const recording = recordState === RecordState.START;
		const audioUrl = audioData ? audioData.url : null; // 获取 Blob URL

		return (
			<div className={this.props.tab === 'recognition' ? 'flowTypeBoxRecognition' : 'flowTypeBox'}>
				{/* <h2>音频录制</h2> */}
				<div style={{ display: 'none' }}>
					<AudioReactRecorder hidden state={recordState} onStop={this.onStop} />
				</div>
				{this.props.tabsName !== 'recognition' &&
					<div style={{ margin: "0 20px 30px 20px" }}>
						{recording ?
							<Timer style={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: '2rem' }}></Timer> :
							<div style={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: '2rem' }}>00:00</div>
						}
					</div>
				}

				<div style={{ display: 'flex', opacity: this.disabled ? '0.5' : '1', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
						<img className='micro' onClick={() => this.handleAudioToggle(recording)} width={100} src={recording ? gif : microphone} alt="" />
					<span className='recordingPrompt' >{isMediaStreamAvailable ? (recording ? '点击完成录音' : (!audioUrl ? '点击开始录音' : '点击重新录音')) : '录音不可用'}</span>
				</div>

				<div>
					{recording ? <Button
						hidden={!recording}
						style={{ border: 'none', background: 'transparent', color: '#FF671D', boxShadow: 'none' }}
						onClick={this.handleCancelRecord}
					>
						取消录音
					</Button> :
						//占位盒子 解决跳动问题
						<div style={{ width: 86, height: 32 }}></div>
					}
				</div>
			</div>
		);
	}
}

export default AudioRecorder;
